import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let AuditService = class AuditService {
    constructor(MarketplaceApi) {
        this.MarketplaceApi = MarketplaceApi;
    }
    getAuditList(params) {
        return this.MarketplaceApi.getAuditList(params.page, params.limit, params.status);
    }
    auditPass(navigation_id) {
        return this.MarketplaceApi.auditPass(navigation_id);
    }
    auditReject(params) {
        return this.MarketplaceApi.auditReject(params.navigation_id, params.reason);
    }
    getNavigationDetail(navigation_id) {
        return this.MarketplaceApi.navigationDetail(navigation_id);
    }
};
AuditService = __decorate([
    injectable(),
    __param(0, inject(Symbols.MarketplaceApi)),
    __metadata("design:paramtypes", [Object])
], AuditService);
export { AuditService };
